import React, { Component } from 'react'
import { translate } from "react-i18next"
import Checkmark from 'cogsworth/components/Checkmark/Checkmark'
import Select from 'react-select'
import * as moment from 'moment'
import { connect } from 'react-redux'
import { setRequestTimeMessage } from 'cogsworth/utils/store'
import { HOURS_OPTIONS, MINUTES_OPTIONS, DAY_OPTIONS } from './dropdowns'
import { DEFAULT_TIME_REQUEST_TEXT } from 'cogsworth/constants'

const DAY_OPTIONS_PAGE_SIZE = 30

class RequestTime extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isOpen: false,
      time: props.time || moment().add(1, 'day').toISOString(),
      dayOptions: DAY_OPTIONS(DAY_OPTIONS_PAGE_SIZE, props.timezone, props.business.dateFormat),
      error: null,
    }

    this.setMessage = this.setMessage.bind(this)
    this.setDay = this.setDay.bind(this)
    this.setMinutes = this.setMinutes.bind(this)
    this.setHours = this.setHours.bind(this)
    this.set = this.set.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.timezone !== this.props.timezone) {
      this.setState({
        dayOptions: DAY_OPTIONS(this.state.dayOptions.length, nextProps.timezone, nextProps.business.dateFormat)
      })
    }
  }

  setMessage(e) {
    this.props.dispatch(setRequestTimeMessage(e.target.value))
  }

  setDay({ value }) {
    const time = moment.tz(this.state.time, this.props.timezone)

    this.setState({
      time: moment.tz(value, this.props.timezone).hour(time.hour()).minute(time.minute()).toISOString()
    })
  }

  setHours({ value }) {
    this.setState({
      time: moment.tz(this.state.time, this.props.timezone).hour(value).toISOString()
    })
  }

  setMinutes({ value }) {
    this.setState({
      time: moment.tz(this.state.time, this.props.timezone).minute(value).toISOString()
    })
  }

  set() {
    this.props.set(this.state.time)
  }

  renderTimeDropdown() {
    const hours = HOURS_OPTIONS(this.props.business.dateFormat)
    const minutes = MINUTES_OPTIONS()

    const { timezone } = this.props
    const time = moment.tz(this.state.time, timezone)

    return (
      <div className="time-picker">
        <span className="error">{ this.state.error }</span>
        <Select
          name="time-day"
          value={this.state.dayOptions.find(h => moment.tz(h.value, timezone).isSame(time.clone().startOf('day')))}
          options={this.state.dayOptions}
          className="dropdown time-day"
          onChange={this.setDay}
          onMenuScrollToBottom={() => {
            this.setState({
              dayOptions: DAY_OPTIONS(this.state.dayOptions.length + DAY_OPTIONS_PAGE_SIZE, timezone, this.props.business.dateFormat)
            })
          }}
        />
        <Select
          name="time-hours"
          value={hours[time.hour()]}
          options={hours}
          className="dropdown time-hours"
          onChange={this.setHours}
        />
        <Select
          name="time-minutes"
          value={minutes[time.minute()]}
          options={minutes}
          className="dropdown time-minutes"
          onChange={this.setMinutes}
        />
      </div>
    )
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.time <= new Date().toISOString() && !this.state.error) {
      this.setState({ error: 'Time can\'t be a past date' })
    }

    if (this.state.time > new Date().toISOString() && this.state.error) {
      this.setState({ error: null })
    }
  }

  body() {
    if (this.state.isSet) {
      return (
        <div>
          <Checkmark />
          <p>You have selected {this.state.time.hours}:{this.state.time.minutes}</p>
          <button className="btn btn-secondary">Unset</button>
        </div>
      )
    }

    const { message } = this.props
    const lines = message.split('\n').length - 1
    const rows = Math.ceil(Math.max(message.length, 1) / 50) + lines
    const { t } = this.props

    return (
      <div className="form">
        <p>{ this.props.business.timeRequestText || DEFAULT_TIME_REQUEST_TEXT }</p>
        { this.renderTimeDropdown() }
        <textarea placeholder="Your message" name="" id="request-time-input" rows={Math.max(rows, 2)} value={message} onChange={this.setMessage} />
        <button className="btn btn-primary" onClick={this.set} disabled={this.state.error !== null}>{ t('continue') }</button>
        <button className="btn btn-secondary" onClick={this.props.cancel}>{ t('cancel') }</button>
      </div>
    )
  }


  render() {
    return (
      <div className="request-time">
        { this.body() }
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  message: state.requestTimeMessage || "",
  timezone: state.timezone,
})

export default connect(mapStateToProps)(translate("translations")(RequestTime))
